<script setup>
import { ref, defineProps, defineModel } from "vue";
import RadioButton from "primevue/radiobutton";
const value = defineModel({ default: "" });
const props = defineProps({
  listName: {
    type: String,
    default: 'houses'
  },

});

const list = {
  houses: [
    { key: "1", name: "1" },
    { key: "2-4", name: "2 a 4" },
    { key: "5-10", name: "5 a 10" },
    { key: ">10", name: "Más de 10" },
  ],
  markets: [
    { key: "1", name: "1" },
    { key: "2-4", name: "2 a 4" },
    { key: "5-10", name: "5 a 10" },
    { key: ">10", name: "Más de 10" },
  ],
  vehicleType: [
    { key: "car", name: "Normal" },
    { key: "truck", name: "Vehiculo Alto" },
    { key: "4x4", name: "Solo 4x4" },
    { key: "motorcycle", name: "Solo Moto" },
    { key: "bicycle", name: "Solo Bicicleta" },
    { key: "walking", name: "Solo Caminando" },
  ],
  security: [
    // tranquilo, normal, inseguro, peligroso, muy peligroso
    { key: "low", name: "Tranquilo" },
    { key: "normal", name: "Normal" },
    { key: "unsafe", name: "Inseguro" },
    { key: "dangerous", name: "Peligroso" },
    { key: "very-dangerous", name: "Muy Peligroso" },
  ],
}

const labes = {
  houses: "Cantidad de casas",
  markets: "Cantidad de negocios",
  vehicleType: "Dificultad de acceso",
  security: "Nivel de seguridad"
}
</script>

<template>
  <div>
    <h3 for="">{{ labes[props.listName] }}</h3>
    <div v-for="option in list[props.listName]" :key="option.key" class="flex align-items-center item">
      <RadioButton v-model="value" :inputId="option.key" name="dynamic" :value="option.key" />
      <label :for="option.key" class="ml-2">{{ option.name }}</label>
    </div>

  </div>
</template>

<style scoped>
h3 {
  font-weight: bold;
  margin: 10px 0;
}
.item {
  margin-bottom: 5px;
}
</style>